export const FETCH_AC_CHARGING_STATION_DATA = 'FETCH_AC_CHARGING_STATION_DATA'
export const ADD_AC_CHARGING_STATION_DATA = 'ADD_AC_CHARGING_STATION_DATA'
export const SET_AC_CHARGING_STATION_LOADER = 'SET_AC_CHARGING_STATION_LOADER'
export const SET_AC_CHARGING_STATIONS_TABLE_PROPS = 'SET_AC_CHARGING_STATIONS_TABLE_PROPS'
export const FETCH_AC_SINGLE_STATION_DETAIL='FETCH_AC_SINGLE_STATION_DETAIL'
export const CLEAR_UPDATED_AC_STATION_DETAIL_DATA = 'CLEAR_UPDATED_AC_STATION_DETAIL_DATA'
export const CLEAR_AC_CHARGING_STATION_LIST_DATA = 'CLEAR_AC_CHARGING_STATION_LIST_DATA'